module.exports = __webpack_public_path__ + "assets/img/th-72a58f8b.png";